var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('app-syncProgress',{attrs:{"syncProgrIndeter":_vm.syncProgrIndeter,"syncStatus":_vm.syncStatus,"syncProgrPercent":_vm.syncProgrPercent,"syncPercent":_vm.syncPercent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }